// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CheckoutPricingTracePage_OverviewQueryVariables = Types.Exact<{
  ccfgId: Types.Scalars['ID']['input'];
}>;


export type CheckoutPricingTracePage_OverviewQuery = { __typename?: 'Query', checkoutPricingTrace: { __typename?: 'CheckoutPricingTrace', baseHousePriceInCents: number, includedPriceInCents: number, selectedPriceInCents: number, checkoutConfig?: { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined } | null | undefined, optionGroups: Array<{ __typename?: 'CheckoutPricingTraceOptionGroup', includedSelectionPriceInCents?: number | null | undefined, packageUpgradeCreditInCents?: number | null | undefined, availableCreditInCents: number, priceChangeInCents: number, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, substepNumber?: number | null | undefined, location?: { __typename?: 'Location', id: string, displayLocationPath: string } | null | undefined, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined }, included?: { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined, selected?: { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined }> } };

export type CheckoutPricingTraceGroupDetailQueryVariables = Types.Exact<{
  pofId: Types.Scalars['ID']['input'];
  oldRpoIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  newRpoIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type CheckoutPricingTraceGroupDetailQuery = { __typename?: 'Query', calculateScopeChange: { __typename?: 'CalculateScopeChangeResult', added: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, name: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } } } | null | undefined }>, removed: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, name: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } } } | null | undefined }> } };

export type CheckoutPricingScopeLineItemDetail_TakeoffLineItemVersionFragment = { __typename?: 'TakeoffLineItemVersion', id: string, name: string, quantity?: number | null | undefined, totalCostInCents: number, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, order: number } }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, preferredBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, displayName: string, blueprintUrl: { __typename?: 'Url', path: string } } } | null | undefined };

export type CheckoutPricingTracePageOverview_TraceFragment = { __typename?: 'CheckoutPricingTrace', baseHousePriceInCents: number, includedPriceInCents: number, selectedPriceInCents: number, checkoutConfig?: { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined } | null | undefined, optionGroups: Array<{ __typename?: 'CheckoutPricingTraceOptionGroup', includedSelectionPriceInCents?: number | null | undefined, packageUpgradeCreditInCents?: number | null | undefined, availableCreditInCents: number, priceChangeInCents: number, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, substepNumber?: number | null | undefined, location?: { __typename?: 'Location', id: string, displayLocationPath: string } | null | undefined, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined }, included?: { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined, selected?: { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined }> };

export type CheckoutPricingTrace_OptionGroupFragment = { __typename?: 'CheckoutPricingTraceOptionGroup', includedSelectionPriceInCents?: number | null | undefined, packageUpgradeCreditInCents?: number | null | undefined, availableCreditInCents: number, priceChangeInCents: number, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, substepNumber?: number | null | undefined, location?: { __typename?: 'Location', id: string, displayLocationPath: string } | null | undefined, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined }, included?: { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined, selected?: { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> } | null | undefined };

export type CheckoutPricingTracePage_OptionStatsFragment = { __typename?: 'CheckoutPricingTraceOptionStats', directCostInCents: number, totalPriceInCents: number, selectionFeeInCents: number, minimumPriceInCents: number, option?: { __typename?: 'ReadyPlanOption', id: string, name: string } | null | undefined, fullConfig: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> };

export const CheckoutPricingScopeLineItemDetail_TakeoffLineItemVersionFragmentDoc = gql`
    fragment CheckoutPricingScopeLineItemDetail_TakeoffLineItemVersion on TakeoffLineItemVersion {
  id
  name
  item {
    id
    name
    costCode {
      id
      displayName
    }
  }
  options {
    id
    name
    optionGroup {
      id
      order
    }
  }
  location {
    id
    displayLocationPath
  }
  quantity
  totalCostInCents
  preferredBidContractLineItem {
    id
    revision {
      id
      displayName
      blueprintUrl {
        path
      }
    }
  }
}
    `;
export const CheckoutPricingTracePage_OptionStatsFragmentDoc = gql`
    fragment CheckoutPricingTracePage_OptionStats on CheckoutPricingTraceOptionStats {
  option {
    ...Named
  }
  fullConfig {
    id
    name
  }
  directCostInCents
  totalPriceInCents
  selectionFeeInCents
  minimumPriceInCents
}
    ${NamedFragmentDoc}`;
export const CheckoutPricingTrace_OptionGroupFragmentDoc = gql`
    fragment CheckoutPricingTrace_OptionGroup on CheckoutPricingTraceOptionGroup {
  group {
    id
    name
    location {
      id
      displayLocationPath
    }
    step {
      code
      name
    }
    substepNumber
  }
  includedSelectionPriceInCents
  packageUpgradeCreditInCents
  availableCreditInCents
  priceChangeInCents
  included {
    ...CheckoutPricingTracePage_OptionStats
  }
  selected {
    ...CheckoutPricingTracePage_OptionStats
  }
}
    ${CheckoutPricingTracePage_OptionStatsFragmentDoc}`;
export const CheckoutPricingTracePageOverview_TraceFragmentDoc = gql`
    fragment CheckoutPricingTracePageOverview_Trace on CheckoutPricingTrace {
  checkoutConfig {
    id
    name
    productOffering {
      id
    }
  }
  baseHousePriceInCents
  includedPriceInCents
  selectedPriceInCents
  optionGroups {
    ...CheckoutPricingTrace_OptionGroup
  }
}
    ${CheckoutPricingTrace_OptionGroupFragmentDoc}`;
export const CheckoutPricingTracePage_OverviewDocument = gql`
    query CheckoutPricingTracePage_Overview($ccfgId: ID!) {
  checkoutPricingTrace(input: {checkoutConfigId: $ccfgId}) {
    ...CheckoutPricingTracePageOverview_Trace
  }
}
    ${CheckoutPricingTracePageOverview_TraceFragmentDoc}`;

/**
 * __useCheckoutPricingTracePage_OverviewQuery__
 *
 * To run a query within a React component, call `useCheckoutPricingTracePage_OverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPricingTracePage_OverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPricingTracePage_OverviewQuery({
 *   variables: {
 *      ccfgId: // value for 'ccfgId'
 *   },
 * });
 */
export function useCheckoutPricingTracePage_OverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables> & ({ variables: CheckoutPricingTracePage_OverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables>(CheckoutPricingTracePage_OverviewDocument, options);
      }
export function useCheckoutPricingTracePage_OverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables>(CheckoutPricingTracePage_OverviewDocument, options);
        }
export function useCheckoutPricingTracePage_OverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables>(CheckoutPricingTracePage_OverviewDocument, options);
        }
export type CheckoutPricingTracePage_OverviewQueryHookResult = ReturnType<typeof useCheckoutPricingTracePage_OverviewQuery>;
export type CheckoutPricingTracePage_OverviewLazyQueryHookResult = ReturnType<typeof useCheckoutPricingTracePage_OverviewLazyQuery>;
export type CheckoutPricingTracePage_OverviewSuspenseQueryHookResult = ReturnType<typeof useCheckoutPricingTracePage_OverviewSuspenseQuery>;
export type CheckoutPricingTracePage_OverviewQueryResult = Apollo.QueryResult<CheckoutPricingTracePage_OverviewQuery, CheckoutPricingTracePage_OverviewQueryVariables>;
export const CheckoutPricingTraceGroupDetailDocument = gql`
    query CheckoutPricingTraceGroupDetail($pofId: ID!, $oldRpoIds: [ID!]!, $newRpoIds: [ID!]!) {
  calculateScopeChange(
    input: {productOfferingId: $pofId, oldConfig: $oldRpoIds, newConfig: $newRpoIds}
  ) {
    added {
      ...CheckoutPricingScopeLineItemDetail_TakeoffLineItemVersion
    }
    removed {
      ...CheckoutPricingScopeLineItemDetail_TakeoffLineItemVersion
    }
  }
}
    ${CheckoutPricingScopeLineItemDetail_TakeoffLineItemVersionFragmentDoc}`;

/**
 * __useCheckoutPricingTraceGroupDetailQuery__
 *
 * To run a query within a React component, call `useCheckoutPricingTraceGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPricingTraceGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPricingTraceGroupDetailQuery({
 *   variables: {
 *      pofId: // value for 'pofId'
 *      oldRpoIds: // value for 'oldRpoIds'
 *      newRpoIds: // value for 'newRpoIds'
 *   },
 * });
 */
export function useCheckoutPricingTraceGroupDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables> & ({ variables: CheckoutPricingTraceGroupDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables>(CheckoutPricingTraceGroupDetailDocument, options);
      }
export function useCheckoutPricingTraceGroupDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables>(CheckoutPricingTraceGroupDetailDocument, options);
        }
export function useCheckoutPricingTraceGroupDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables>(CheckoutPricingTraceGroupDetailDocument, options);
        }
export type CheckoutPricingTraceGroupDetailQueryHookResult = ReturnType<typeof useCheckoutPricingTraceGroupDetailQuery>;
export type CheckoutPricingTraceGroupDetailLazyQueryHookResult = ReturnType<typeof useCheckoutPricingTraceGroupDetailLazyQuery>;
export type CheckoutPricingTraceGroupDetailSuspenseQueryHookResult = ReturnType<typeof useCheckoutPricingTraceGroupDetailSuspenseQuery>;
export type CheckoutPricingTraceGroupDetailQueryResult = Apollo.QueryResult<CheckoutPricingTraceGroupDetailQuery, CheckoutPricingTraceGroupDetailQueryVariables>;